<template>
    <div
        class="md:w-full md:max-w-[400px] absolute left-1 right-1 top-1/2 md:top-36 lg:top-24 md:h-[85vh] md:max-h-[95%] md:left-auto md:right-6 bottom-2 md:bottom-auto rounded-lg border border-slate-200 shadow-lg p-2 bg-white z-1050"
        v-if="show"
        style="transform: translate3d(0, 0, 170px)"
    >
        <div class="relative h-full flex flex-col" style="isolation: isolate;">
            <div
                class="absolute right-2 top-2 flex justify-center items-center gap-2"
            >
                <FavButton
                    buttonClass="bg-white rounded-full p-1.5"
                    :isFavorite="isFavoriteLounge ? isFavoriteLounge : false"
                    @toggleFavorite="handleToggleFavorite"
                />
                <button
                    @click="$emit('close')"
                    class="w-8 h-8 bg-white rounded-full shadow justify-center items-center p-2 text-slate-500 text-xl flex transition-colors z-60 hover:text-slate-400 hover:border-slate-300 hover:bg-slate-200 active:border-slate-300 active:bg-slate-200 focus:outline-none focus:border-2 cursor-pointer"
                >
                    <Icon icon="close" />
                    <span class="sr-only">Close</span>
                </button>
            </div>
            <div class="active:outline-none">
                <ImageLoader>
                    <template #image>
                        <div
                            class="w-full h-52 bg-center bg-cover bg-no-repeat rounded-md"
                            :data-src="infoWindowContent.featured_image.src"
                            :style="`background-image: url('${infoWindowContent.featured_image.src}')`"
                        ></div>
                    </template>
                    <template #preloader>
                        <div
                            class="w-full h-52 rounded-md bg-slate-200 shimmer"
                        ></div>
                    </template>
                    <template #error>
                        <div
                            class="w-full h-52 flex items-center justify-center rounded-md bg-slate-200 text-slate-400"
                        >
                            <Icon icon="no-image" />
                        </div>
                    </template>
                </ImageLoader>
            </div>

            <div class="overflow-y-auto relative mt-1 px-1">
                <div class="pt-2 flex-col justify-start items-start flex">
                    <div
                        class="self-stretch flex-col justify-start items-start flex"
                    >
                        <h1
                            class="self-stretch justify-start items-start flex grow shrink basis-0 text-slate-800 text-xl font-medium leading-7"
                        >
                            {{ infoWindowContent?.name?.short }}
                        </h1>

                        <p
                            class="pt-1 self-stretch text-slate-500 text-sm font-normal leading-tight"
                        >
                            {{ infoWindowContent.location }}
                            ·

                            {{ infoWindowContent.airport?.name }}
                        </p>
                        <div class="pt-4 gap-5 justify-start items-start flex">
                            <LoungeHours
                                :hoursData="
                                    infoWindowContent.business_hours || null
                                "
                                :isOpen="infoWindowContent.open_now"
                                :timing="infoWindowContent.timing || null"
                                v-if="
                                    infoWindowContent.business_hours ||
                                    infoWindowContent.timing
                                "
                            />
                            <a
                                v-if="infoWindowContent.website"
                                :href="infoWindowContent.website"
                                target="_blank"
                                class="flex rounded justify-start items-center gap-2 text-slate-800 cursor-pointer"
                            >
                                <Icon
                                    icon="globe"
                                    svgClass="h-5 w-5 fill-none"
                                />
                                <p
                                    class="text-slate-800 text-sm font-medium leading-tight"
                                >
                                    Lounge website
                                </p>
                            </a>
                        </div>
                        <div
                            class="self-stretch pt-6 justify-start items-start flex"
                        >
                            <div
                                v-if="infoWindowContent.operator"
                                class="grow shrink basis-0 pr-3 flex-col justify-center items-start gap-1 flex"
                            >
                                <h3
                                    class="self-stretch text-slate-500 text-sm font-normal leading-tight"
                                >
                                    Operated by
                                </h3>
                                <div
                                    class="justify-start items-center gap-2 flex"
                                >
                                    <img
                                        v-if="infoWindowContent.operator?.image"
                                        class="bg-white p-1 rounded-lg border border-slate-200 justify-center items-center gap-2.5 flex w-24 h-9 lg:w-36 lg:h-12 lg:px-2"
                                        :src="`${doEndpoint}/${infoWindowContent.operator?.image?.path}/${infoWindowContent.operator?.image?.file_name}`"
                                    />
                                    <div
                                        v-else
                                        class="items-center gap-2.5 flex w-24 h-9 lg:w-36 lg:h-12"
                                    >
                                        <div
                                            class="w-full h-full flex items-center justify-start"
                                        >
                                            <LoungeIcon
                                                icon="airplane"
                                                class="shrink-0 bg-slate-200 p-1 rounded-lg"
                                            />
                                            <span
                                                class="text-slate-800 text-sm font-medium leading-tight ml-2"
                                            >
                                                {{
                                                    infoWindowContent?.operator
                                                        ?.name
                                                }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="grow shrink basis-0 pr-3 flex-col justify-center items-start gap-1 flex"
                                v-if="
                                    infoWindowContent.alliance &&
                                    infoWindowContent.alliance !== 'None'
                                "
                            >
                                <h3
                                    class="self-stretch text-slate-500 text-sm font-normal leading-tight"
                                >
                                    Alliance
                                </h3>
                                <div
                                    class="bg-white p-1 rounded-lg border border-slate-200 justify-center items-center gap-2.5 flex w-24 h-9 lg:w-36 lg:h-12 lg:px-2"
                                >
                                    <div
                                        v-if="
                                            infoWindowContent.alliance &&
                                            infoWindowContent.alliance !==
                                                'None'
                                        "
                                        class="items-center justify-center flex w-24 h-9 lg:w-36 lg:h-12"
                                    >
                                        <LoungeIcon
                                            v-if="
                                                infoWindowContent.alliance ==
                                                'OneWorld'
                                            "
                                            icon="one_world_alliance_logo"
                                            class="shrink-0 p-1 rounded-lg lg:h-10 lg:w-10 w-8 h-8"
                                        />
                                        <LoungeIcon
                                            v-else-if="
                                                infoWindowContent.alliance ==
                                                'Star Alliance'
                                            "
                                            icon="star_alliance_logo"
                                            class="shrink-0 p-1 rounded-lg lg:h-10 lg:w-10 w-8 h-8"
                                        />
                                        <LoungeIcon
                                            v-else-if="
                                                infoWindowContent.alliance ==
                                                'SkyTeam'
                                            "
                                            icon="sky_team_alliance_logo"
                                            class="shrink-0 p-1 rounded-lg lg:h-10 lg:w-10 w-8 h-8"
                                        />
                                    </div>
                                    <div
                                        v-else
                                        class="items-center gap-2.5 flex w-24 h-9 lg:w-36 lg:h-12"
                                    >
                                        <div
                                            class="w-full h-full flex items-center justify-start"
                                        >
                                            <Icon
                                                icon="globe"
                                                class="shrink-0 bg-slate-200 p-1 rounded-lg"
                                            />
                                            <span
                                                class="text-slate-800 text-sm font-medium leading-tight ml-2"
                                            >
                                                {{ infoWindowContent.alliance }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- START OVERVIEW -->
                <div
                    class="self-stretch flex-col justify-start items-start flex"
                    v-if="computedOverview"
                >
                    <h2
                        class="self-stretch pt-10 pb-6 text-slate-800 text-lg font-medium leading-7"
                    >
                        Overview
                    </h2>
                    <div
                        class="self-stretch flex-col justify-start items-start flex bg-white rounded-lg"
                    >
                        <ExpandableSection
                            sectionClass="flex-col justify-start items-start gap-4 flex transition-all ease-in-out duration-300 relative prose"
                        >
                            <template #content>
                                <div
                                    class="lounge-overview-text text-slate-800 text-sm font-normal leading-tight"
                                    v-html="computedOverview"
                                ></div>
                            </template>
                        </ExpandableSection>
                    </div>
                </div>
                <!-- END OVERVIEW -->
                <!-- START AMENITIES -->
                <div
                    v-if="sortedAmenities.length"
                    class="self-stretch flex-col justify-start items-start flex"
                >
                    <h2
                        class="self-stretch pb-6 pt-10 text-slate-800 text-lg font-medium leading-7"
                    >
                        Amenities
                    </h2>
                    <div
                        class="self-stretch flex-col justify-start items-start flex bg-white rounded-lg"
                    >
                        <ExpandableSection
                            sectionClass="self-stretch flex-col justify-start items-start gap-4 flex transition-all ease-in-out duration-300 relative"
                        >
                            <template #content>
                                <div
                                    class="gap-6 grid grid-cols-2 grid-flow-row w-full"
                                >
                                    <AmenityListItem
                                        v-for="amenity in sortedAmenities"
                                        :key="amenity.value"
                                        :label="amenity.label"
                                        :icon="amenity.icon"
                                    />
                                </div>
                            </template>
                        </ExpandableSection>
                    </div>
                </div>
                <!-- START ACCESS -->
                <div
                    v-if="computedAccess"
                    class="self-stretch flex-col justify-start items-start flex"
                >
                    <h2
                        class="self-stretch pb-6 pt-10 text-slate-800 text-lg font-medium font-['Inter'] leading-7"
                    >
                        Access
                    </h2>
                    <div
                        class="self-stretch flex-col justify-start items-start flex bg-white rounded-lg"
                    >
                        <ExpandableSection
                            sectionClass="self-stretch flex-col justify-start items-start gap-4 flex transition-all ease-in-out duration-300 relative"
                        >
                            <template #content>
                                <div
                                    class="lounge-access-text text-slate-800 text-sm font-normal font-['Inter'] leading-tight"
                                    v-html="computedAccess"
                                ></div>
                            </template>
                        </ExpandableSection>
                    </div>
                </div>
                <!-- START AIRLINES -->
                <div
                    class="self-stretch flex-col justify-start items-start flex pb-16"
                    v-if="infoWindowContent?.airline?.length"
                >
                    <h2
                        class="pb-6 pt-10 flex-col justify-center items-start gap-1 flex self-stretch text-slate-800 text-lg font-medium leading-7"
                    >
                        Airlines
                    </h2>
                    <div
                        class="self-stretch bg-white rounded-lg flex-col justify-start items-start flex"
                    >
                        <div
                            class="self-stretch grow shrink basis-0 flex-col justify-start items-start flex"
                        >
                            <p
                                class="self-stretch text-slate-800 text-sm font-normal leading-tight"
                            >
                                You may have access to the
                                {{ infoWindowContent.name.short }} as a premium
                                customer of one of the following airlines, or as
                                an elite member of their frequent flyer program.
                                Check the Access rules section for more details.
                            </p>
                            <div
                                class="self-stretch pt-8 flex-col justify-start items-start flex"
                            >
                                <div
                                    v-if="
                                        infoWindowContent.alliance &&
                                        infoWindowContent.alliance !== 'None'
                                    "
                                    class="flex-col justify-start items-start gap-1 flex pb-4"
                                >
                                    <h3
                                        class="self-stretch text-slate-800 text-base font-medium font-['Inter'] leading-normal"
                                    >
                                        {{ infoWindowContent.alliance }}
                                    </h3>
                                    <p
                                        class="self-stretch text-slate-500 text-sm font-normal font-['Inter'] leading-tight"
                                    >
                                        Access for eligible customers traveling
                                        on any
                                        {{ infoWindowContent.alliance }} member
                                        airline.
                                    </p>
                                </div>
                                <ExpandableSection
                                    sectionClass="self-stretch flex-col justify-start items-start flex transition-all ease-in-out duration-300 relative"
                                >
                                    <template #content>
                                        <div
                                            class="py-3 gap-6 flex flex-col w-full"
                                        >
                                            <OperatorItem
                                                v-for="airline in infoWindowContent?.airline"
                                                :name="airline.name"
                                                :code="airline.code"
                                                :img="airline.image"
                                            />
                                        </div>
                                    </template>
                                </ExpandableSection>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <LoadingState :loading="loading" />
    </div>
</template>
<script setup>
import { computed, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useLoungesStore } from '@/store/lounges';
import AmenityListItem from '@/components/tools/lounges/partials/amenity-list-item/amenity-list-item.vue';
import ExpandableSection from '@/components/ui/expandable-section/ui-expandable-section.vue';
import OperatorItem from '@/components/tools/lounges/partials/operator-item/operator-item.vue';
import FavButton from '@/components/ui/fav-button/fav-button.vue';
import LoadingState from '@/components/ui/loading-state/loading-state.vue';
import LoungeHours from '@/components/tools/lounges/partials/lounge-hours/lounge-hours.vue';
import ImageLoader from '@/components/ui/image-loader/image-loader.vue';
import Icon from '@/components/ui/icon/icon.vue';
import LoungeIcon from '@/components/tools/lounges/partials/lounge-icon/lounge-icon.vue';

const props = defineProps({
    infoWindowContent: Object,
    show: { type: Boolean, default: false },
});

const emit = defineEmits(['favoriteChanged']);
const loungesStore = useLoungesStore();
const { toggleFavorite } = loungesStore;
const { loading } = storeToRefs(loungesStore);
const isFavoriteLounge = ref(props.infoWindowContent.favorite);
const doEndpoint = ref(import.meta.env.VITE_DO_CDN_ENDPOINT);

const computedOverview = computed(() => {
    if (props.infoWindowContent?.content) {
        var textArea = document.createElement('textarea');
        textArea.innerHTML = props.infoWindowContent.content;
        return textArea.value;
    }
    return null;
});

const sortedAmenities = computed(() => {
    if (props.infoWindowContent?.amenities) {
        return props.infoWindowContent.amenities.sort((a, b) => {
            if (a.label < b.label) {
                return -1;
            }
            if (a.label > b.label) {
                return 1;
            }
            return 0;
        });
    }
    return null;
});

const computedAccess = computed(() => {
    if (props.infoWindowContent?.accesspolicy) {
        var textArea = document.createElement('textarea');
        textArea.classList.add('access-textarea');
        textArea.innerHTML = props.infoWindowContent.accesspolicy;
        return textArea.value;
    }
});

const handleToggleFavorite = async () => {
    isFavoriteLounge.value = !isFavoriteLounge.value;

    const res = await toggleFavorite(props.infoWindowContent, 'lounge');
    if (!res || res.status !== 200) {
        isFavoriteLounge.value = !isFavoriteLounge.value;
    }

    emit('favoriteChanged');
};

watch(
    () => props.infoWindowContent,
    (newVal) => {
        isFavoriteLounge.value = newVal.favorite;
    }
);
</script>
